import React, { useEffect, useState } from 'react';
import '../../App.css';
import '../../Styles/Admins/Admin-login.css';
import { useNavigate } from 'react-router-dom';
import { adminForgetPassword } from '../../services/authService';
import { adminPasswordOtp } from '../../services/authService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function AdminForgetPassword() {
    // debugger;
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [newpassword, setNewPassword] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [getOtpButtonDisable, setgetOtpButtonDisable] = useState(false);


    const handleChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,6}$/.test(value)) { // Regex to allow only numbers with max length 6
            setOtp(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            let reqobj = {
                email: email,
            }
            const data = await adminPasswordOtp(reqobj);
            if (data) {
                //console.log("Success message:", data.message);
                toast.success(data.message);
                setShowForm(true);
                setgetOtpButtonDisable(true);
            }
        } catch (error) {
            //console.log('Login failed:', error.response.data.errors);
            // toast.error(error.response.data.errors);
        }

        setIsLoading(false);
    }

    const submitPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            let reqobj = {
                email: email,
                otp: otp,
                password: newpassword
            }
            const data = await adminForgetPassword(reqobj);
            if (data) {
                //console.log("Success message:", data.message);
                toast.success(data.message);
                navigate('/Admin/login');
            }


        } catch (error) {
            // debugger
            // toast.error(error.response.data.errors);
            //console.error('Login failed:', error);
        }

        setIsLoading(false);
    }
    const login = () => {
        // debugger;
        // event.preventDefault();
        // console.log("Forgot Password clicked");
        navigate('/Admin/login');
    }

    return (
        <div id="224" className="p-0">
            <div id="225" className="grid grid-cols-12 ">
                <div id="226" className="lg:col-span-5 md:col-span-12 sm:col-span-12">
                    <div id="227" className="relative h-auto">
                        <div>
                            <img className="w-full h-screen" alt='loginbg' src="./images/loginreg_bg.png" />
                        </div>
                        <div id="228" className="absolute top-1/4 left-1/4 h-1/2 flex justify-center">
                            <img className="" alt='login-doctor' src="./images/login_doctor_bg.png" id="doctorinner" />
                        </div>
                    </div>
                </div>
                <div id="229" className="lg:col-span-7 md:col-span-12 sm:col-span-12">
                    <div id="230" className="flex flex-col justify-center h-full m-2">
                        <div id="231" className="px-28">
                            <img src="./images/ciana.png" id="docisnlogo" className="h-2/3 w-2/4 ps-6" alt='docisn-logo' />
                        </div>


                        {showForm ?
                            <>
                                <div id="232" className="text-2xl px-40 font-semibold mb-4">Reset Password</div>
                                <form className="lg:w-full px-40" onSubmit={submitPassword}>
                                    <a className='font-medium cursor-pointer' onClick={() => { setShowForm(!showForm); setgetOtpButtonDisable(false) }}> &lt; Back </a>
                                    <div className='mb-2'>
                                        <label htmlFor="otp" className='text-base font-medium'>OTP</label>
                                        <input
                                            type="text"
                                            className="w-full px-4 py-2 mt-2 border rounded-md "
                                            id="otp"
                                            value={otp}
                                            onChange={handleChange}
                                            required
                                            minLength={4}
                                            maxLength={6}
                                            pattern="\d{6}"
                                            title="OTP must be exactly 6 digits"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="password" className='text-base font-medium'>New Password</label>
                                        <input
                                            type="text"
                                            className="w-full px-4 py-2 mt-2 border rounded-md "
                                            id="newpassword"
                                            value={newpassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div id="238" className="mt-3">
                                        <button className="signinbtn" type="submit" disabled={isLoading} id="signIn">Submit</button>
                                    </div>
                                </form>
                                <div className='lg:w-full px-40 py-5 text-end font-medium'>Return to <a onClick={login} className='cursor-pointer font-medium'>Sign In</a></div>
                            </> :
                            <>
                                <div id="232" className="text-2xl px-40 font-semibold mb-4">Forgot Password</div>
                                <form className="lg:w-full px-40" onSubmit={handleSubmit}>
                                    <div className='mb-2'>
                                        <label htmlFor="email" className='text-base font-medium'>Email</label>
                                        <input
                                            type="email"
                                            className="block w-full px-4 py-2 mt-2 border rounded-md "
                                            id="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div id="238" className="each-row-btn">
                                        <button className="signinbtn" type="submit" disabled={getOtpButtonDisable} id="signIn" >Get OTP</button>
                                    </div>
                                </form>
                                <div className='lg:w-full px-40 text-end font-medium' >Return to <a onClick={login} className='cursor-pointer font-medium'>Sign In</a></div>
                            </>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminForgetPassword;